import gql from 'graphql-tag';

export const MediaPartnerNoticesQuery = gql`
	query MediaPartnerNoticesData {
		allMediaPartnerNotices {
			partnerNotices {
				name
				utmSource
				payment
				isInvestor
				isCpaPartner
				customPaymentCondition
				monthlyPayment
			}
		}
	}
`;
